import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Icon from '../Icon';

// technically all we really need is to set the props to 
// "React.ComponentPropsWithoutRef<typeof Svg>", but in order for our custom
// props to come through in Storybook we need to bring them up again here 

export default function NewMessageIcon(_ref) {
  let {
    contextType = 'image',
    className = '',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 211.5 176"
  }, props, {
    contextType: contextType,
    className: `pi pi-new-message-icon ${className}`
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    width: "150",
    height: "150",
    transform: "translate(31.152 26.05)",
    overflow: "visible",
    opacity: ".3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: "105.895",
    y1: "162.887",
    x2: "105.895",
    y2: "31.686"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#777"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M161.9 162.9h-112c-5.3 0-9.6-4.3-9.6-9.6v-112c0-5.3 4.3-9.6 9.6-9.6h112c5.3 0 9.6 4.3 9.6 9.6v112c0 5.3-4.3 9.6-9.6 9.6z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("image", {
    width: "90",
    height: "87",
    transform: "translate(61.152 57.05)",
    overflow: "visible",
    opacity: ".3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8 130.7v-1.1-34.3c0-.7.2-1.1.7-1.5 3-2.7 5.9-5.4 8.8-8.1.4-.4.6-.8.6-1.4V74v-1.1h12.5c.5 0 1.1-.2 1.4-.6 3.1-2.8 6.1-5.6 9.2-8.4 1.5-1.4 2.8-1.4 4.3 0 3 2.7 5.9 5.5 8.9 8.2.6.6 1.2.8 2.1.8h11.1c.8 0 1.1.3 1 1.1v10.4c0 .6.2 1 .6 1.4 2.9 2.7 5.8 5.3 8.7 8 .5.5.8 1 .8 1.8v35.3c-23.7-.2-47.1-.2-70.7-.2zm65.5-29c-.3.1-.6.2-.8.3-9.2 3.6-18.5 7.1-27.7 10.7-1.2.4-2.2.5-3.4 0-9.2-3.6-18.4-7.1-27.6-10.6-.3-.1-.5-.2-.9-.3v23.9h60.3c.1-8.1.1-16 .1-24zM86 77.9v21.6c0 .5.2.7.6.9 6.3 2.4 12.5 4.8 18.8 7.2.4.1.9.1 1.3 0 6.1-2.3 12.3-4.7 18.4-7 .9-.3 1.1-.8 1.1-1.8v-2-17.9-1.1c-13.4.1-26.8.1-40.2.1zm15.7-5.2h8.7c-1.5-1.4-2.9-2.7-4.4-4-1.4 1.3-2.7 2.6-4.3 4zM80.9 92c-1.6 1.5-3.1 2.9-4.7 4.4 1.7.6 3.2 1.2 4.7 1.8V92zm55.1 4.3c-1.6-1.5-3.1-2.9-4.7-4.3v6.1c1.6-.6 3.1-1.1 4.7-1.8z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M91 82.9h30.2v4.6H91zM91 92.8h20.1v4.6H91z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    width: "80",
    height: "80",
    transform: "translate(131.152 -3.95)",
    overflow: "visible",
    opacity: ".3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "171.5",
    cy: "32.3",
    r: "30.5",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: "171.496",
    y1: "58.245",
    x2: "171.496",
    y2: "6.258"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#555"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: "171.5",
    cy: "32.3",
    r: "26",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    width: "29",
    height: "41",
    transform: "translate(155.152 16.05)",
    overflow: "visible",
    opacity: ".3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.3 43.5V29.1h-5.6v-3.4c.8 0 1.5 0 2.3-.2.7-.1 1.4-.4 2-.7.6-.3 1.1-.8 1.5-1.4.4-.6.7-1.3.8-2.1h3.6v22.2h-4.6z",
    fill: "#fff"
  }))));
}